import TabbedDialog from 'global/guides/Dialog/TabbedDialog'
import { useAuth } from 'hooks'
import { hasPermission } from 'hooks/useBackendMenu'
import {
    createRegrasCalculoSchema,
    RegraCalculoPresenter,
    regrasCalculo,
} from 'service/api'
import { toast } from 'sonner'
import { updateRascunho } from 'templates/Cadastro/Funcionarios/organismos/modals/Adicionar'
import { horasExtrasModel as defaultValues } from '../../constants'
import {
    TabGeral,
    TabHorasExtras,
    TabHoristaEFaltas,
    TabNoturno,
} from '../forms/FormRegraCalculo'

const TABS = [
    { name: 'geral', label: 'Geral', content: <TabGeral /> },
    { name: 'horasExtras', label: 'Horas extras', content: <TabHorasExtras /> },
    { name: 'noturno', label: 'Noturno', content: <TabNoturno /> },
    {
        name: 'horista',
        label: 'Horista e faltas',
        content: <TabHoristaEFaltas />,
    },
]

export default function AdicionarRegrasCalculo() {
    const {
        decoded: { cliente: clienteId },
    } = useAuth()
    const { mutateAsync, isLoading } = regrasCalculo.mutations.useCreate({
        invalidateQuery: true,
        onSuccess: res => {
            updateRascunho({ regraCalculo: res.id })
            toast.success('Regra de cálculo adicionada com sucesso')
        },
        onError: e => {
            toast.error(e.message)
        },
    })

    return (
        <TabbedDialog.Root
            tabs={TABS}
            open={hasPermission(['create', 'RegrasDeCálculo'])}
            width="62rem"
            defaultValues={{
                ...defaultValues,
                horasExtras: {
                    ...defaultValues.horasExtras,
                    semanal: {
                        qtdPrimeirasHrs: '08:00',
                        porcentagemPrimeirasHrs: null,
                        porcentagemDemaisHrs: null,
                    },
                    mensal: {
                        qtdPrimeirasHrs: '30:00',
                        porcentagemPrimeirasHrs: null,
                        porcentagemDemaisHrs: null,
                    },
                },
                horarioInicioAdicionalNoturno: '22:00',
                horarioFimAdicionalNoturno: '05:00',
                adicionalNoturno: 20,
            }}
            schema={createRegrasCalculoSchema}
            loading={isLoading}
            onSubmit={(data: RegraCalculoPresenter) =>
                mutateAsync({ ...data, clienteId })
            }
        >
            <TabbedDialog.Title>Adicionar regra de cálculo</TabbedDialog.Title>
            <TabbedDialog.Content dividers />
            <TabbedDialog.Actions>
                <TabbedDialog.Actions.SecondaryButton />
                <TabbedDialog.Actions.PrimaryButton closeOnSubmit />
            </TabbedDialog.Actions>
        </TabbedDialog.Root>
    )
}
